import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { ITrainingPhaseProfessionalSituationResource } from "../types";

const getResourcePath = (resource: RelationalValue<ITrainingPhaseProfessionalSituationResource>) =>
    typeof resource === "string" ? resource : resource["@id"];

export interface ITrainingPhaseProfessionalSituationDeleteMutationParameters {
    trainingPhaseProfessionalSituation: RelationalValue<ITrainingPhaseProfessionalSituationResource>;
}

export type ITrainingPhaseProfessionalSituationDeleteMutationResult = ITrainingPhaseProfessionalSituationResource;

export const trainingPhaseProfessionalSituationDeleteMutation: IApiMutationFunction<
    ITrainingPhaseProfessionalSituationDeleteMutationParameters
> = ({ trainingPhaseProfessionalSituation }) => ({
    method: "DELETE",
    url: getResourcePath(trainingPhaseProfessionalSituation),
});

export const useTrainingPhaseProfessionalSituationDeleteMutation = createApiMutationHook<
    ITrainingPhaseProfessionalSituationDeleteMutationParameters,
    ITrainingPhaseProfessionalSituationDeleteMutationResult
>(trainingPhaseProfessionalSituationDeleteMutation);
